<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">安全自查活动列表</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="活动状态">
          <el-select v-model="formInline.status" clearable filterable placeholder="请选择">
            <el-option v-for="item in $store.state.activityStatus" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="活动名称">
          <el-input v-model="formInline.name" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="检查对象">
          <el-select v-model="formInline.target_id" clearable filterable :placeholder="`请选择`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="检查人员">
          <el-select v-model="formInline.member_id" clearable filterable :loading="loading" remote
            :remote-method="remoteMethod" placeholder="请选择">
            <el-option v-for="item in users" :key="item.id" :label="item.name" :value="item.id">
              <p>{{ item.name }}</p>
              <p v-if="item.number" class="el-option-tips">工号：{{ item.number }}</p>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">创建活动</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column fixed label="序号" type="index" width="50">
        </custom-table-column>
        <custom-table-column prop="name" fixed label="活动名称" min-width="160px">
        </custom-table-column>
        <custom-table-column prop="status_text" label="活动状态" width="150">
        </custom-table-column>
        <custom-table-column prop="target_name" label="检查对象" min-width="160px">
        </custom-table-column>
        <custom-table-column prop="frequency_text" label="自查频率" width="100px">
        </custom-table-column>
        <custom-table-column prop="start_time" label="自查开始时间" width="160px">
        </custom-table-column>
        <custom-table-column prop="end_time" label="自查结束时间" width="160px">
        </custom-table-column>
        <custom-table-column prop="member_name" label="检查人员" width="200px">
        </custom-table-column>
        <!-- <custom-table-column prop="standards" label="指标项" min-width="340px">
          <template slot-scope="scope"  v-if="scope.row.reports&&scope.row.reports.length>0">
            <p v-for="item in scope.row.reports">
              {{ item.standard_name }};
            </p>
          </template>
</custom-table-column> -->
        <custom-table-column prop="desc" label="活动描述" min-width="220px">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="text" @click="handleChildren(scope.row)" size="small">查看详情</el-button>
            <template v-if="scope.row.status == 0">
              <el-button @click="handleEditNew(scope.row)" type="text" size="small">编辑</el-button>
              <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
            </template>
            <!-- <el-button v-if="scope.row.status == 2" @click="handleDetail(scope.row)" type="text"
              size="small">查看结果</el-button> -->
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="746px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="活动名称" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="自查频率" prop="frequency">
          <el-radio-group v-model="ruleForm.frequency" style="width:216px;">
            <el-radio v-for="item in $store.state.frequencys" :key="item.value" :label="item.value">{{ item.label
            }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="自查开始时间" prop="start_time">
          <el-date-picker type="datetime" placeholder="请选择" value-format="yyyy-MM-dd HH:mm:ss"
            v-model="ruleForm.start_time" style="width: 216px;" :picker-options="pickerOptions"></el-date-picker>
        </el-form-item>
        <el-form-item label="自查结束时间" prop="end_time">
          <el-date-picker type="datetime" placeholder="请选择" value-format="yyyy-MM-dd HH:mm:ss"
            v-model="ruleForm.end_time" style="width: 216px;" :picker-options="pickerOptions1"></el-date-picker>
        </el-form-item>
        <el-form-item label="检查对象" prop="target_id">
          <el-select v-model="ruleForm.target_id" clearable filterable :placeholder="`请选择`" @change="handleTargetChange"
            style="width: 216px;">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="检查人员" prop="member_id">
          <el-select v-model="ruleForm.member_id" clearable style="width:216px;" filterable reserve-keyword
            :loading="loading" remote :remote-method="remoteMethod" placeholder="请选择">
            <el-option v-for="item in users" :key="item.id" :label="item.name" :value="item.id">
              <p>{{ item.name }}</p>
              <p v-if="item.number" class="el-option-tips">工号：{{ item.number }}</p>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="指标项" prop="standards">
          <el-cascader v-model="ruleForm.standards" filterable ref="cascader" :props="props" :show-all-levels="false"
            style="width:552px;" clearable :options="standards">
            <template slot-scope="{ node, data }">
              <p>{{ data.name }}</p>
              <p v-if="data.id" class="cascader-tip">标准：{{ data.value }}</p>
            </template>
          </el-cascader>
        </el-form-item>
        <el-form-item label="活动描述" prop="desc">
          <el-input type="textarea" v-model="ruleForm.desc" :rows="5" placeholder="请输入" style="width:552px;"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type == 'add'"
            @click="submitFormByFun('ruleForm', createMethod)">确认</el-button>
          <el-button type="primary" v-if="type == 'edit'"
            @click="submitFormByFun('ruleForm', updateMethod)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="活动详情" :visible.sync="resultDialogVisible" width="946px">
      <div>
        <custom-table :data="tableData1" border style="width: 100%">
          <custom-table-column fixed label="序号" type="index" width="50">
          </custom-table-column>
          <custom-table-column prop="name" fixed label="活动名称" min-width="160px">
          </custom-table-column>
          <custom-table-column prop="status" label="活动状态" width="150" label-class-name="activityStatus"
            :formatter="format_arr">
          </custom-table-column>
          <custom-table-column prop="target_name" label="检查对象" min-width="160px">
          </custom-table-column>
          <custom-table-column prop="start_time" label="自查开始时间" width="160px">
          </custom-table-column>
          <custom-table-column prop="end_time" label="自查结束时间" width="160px">
          </custom-table-column>
          <custom-table-column prop="member_name" label="检查人员" width="200px">
          </custom-table-column>
          <custom-table-column prop="standards" label="指标项" min-width="340px">
            <template slot-scope="scope" v-if="scope.row.reports && scope.row.reports.length > 0">
              <p v-for="item in scope.row.reports">
                {{ item.standard_name }};
              </p>
            </template>
          </custom-table-column>
          <custom-table-column fixed="right" label="操作" width="150">
            <template slot-scope="scope">
              <el-button v-if="scope.row.status == 2" @click="handleDetail(scope.row)" type="text"
                size="small">查看结果</el-button>
            </template>
          </custom-table-column>
        </custom-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resultDialogVisible = false">取 消</el-button>
        <!-- <el-button type="primary" @click="deleteTarinRoom">确 定</el-button> -->
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="查看结果" :visible.sync="detailDialogVisible" width="846px">
      <SafeSelfCheckRusult :rowObj="rowObj" />
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinValidate } from '@/assets/js/mixin/validate';
import { mixinFormatter } from '@/assets/js/mixin/formatter';
import SafeSelfCheckRusult from "./components/safeSelfCheckRusult";

export default {
  name: 'equipmentInto',
  mixins: [mixinList, mixinValidate, mixinFormatter],
  data() {
    return {
      formInline: {
        name: '',
        status: '',
        target_id: '',
        member_id: '',
      },
      formInline1: {
        id: ''
      },
      detailDialogVisible: false,
      resultDialogVisible: false,
      props: { multiple: true, value: 'name', label: 'value', emitPath: false },
      users: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < (Date.now() - 24 * 60 * 60 * 1000);
        },
      },
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
      ruleForm: {
        name: '',
        start_time: '',
        end_time: '',
        target_id: '',
        member_id: '',
        frequency: '',
        standards: [],
        desc: '',
      },
      rowObj: {},
      tableData1: [],
      loading: false,
      standards: [],
      rules: {
        name: [{ required: true, message: '请输入', trigger: 'blur' }],
        start_time: [{ required: true, message: '请选择', trigger: 'change' }],
        end_time: [{ required: true, message: '请选择', trigger: 'change' }],
        frequency: [{ required: true, message: '请选择', trigger: 'change' }],
        standards: [{ required: true, message: '请选择', trigger: 'change' }],
        target_id: [{ required: true, message: '请选择', trigger: 'change' }],
        member_id: [{ required: true, message: '请选择', trigger: 'change' }],
      },
    };
  },
  components: {
    SafeSelfCheckRusult
  },
  created() {
    this.$store.dispatch('getTarinMent');
    
    this.getStandards()
  },
  mounted() {
  },
  methods: {
    async deleteMethod() {
      let res = await this.$api.instance.interfaceServer(`api/self-check-activity/delete/${this.delid}`, 'delete');
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },

    handleChildren(row) {
      this.formInline1.id = row.id
      this.tableData1 = []
      this.resultDialogVisible = true;
      this.handleQuery1()
    },
    handleQuery1() {
      this.$nextTick(() => {
        this.getList1();
      });
    },
    async getList1() {
      let res = await this.$api.instance.interfaceServer(`api/self-check-activity/sub-activities/${this.formInline1.id}`, 'get');
      if (res.code == 0 && res.data) {
        this.tableData1 = res.data;
      }
    },
    async getStandards() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      let res = await this.$api.instance.interfaceServer('api/safety_check/standard/list', 'get', params);
      if (res.code == 0 && res.data && res.data.length > 0) {
        this.standards = this.getStandardsItem(res.data);
      }
    },
    getStandardsItem(arr) {
      return arr.map(item => {
        if ((item.children && item.children.length > 0) || (item.list && item.list.length > 0)) {
          this.getStandardsItem(item.children || item.list);
          item.children = item.children || item.list;
        }
        return item;
      });
    },
    handleDetail(row) {
      this.detailDialogVisible = true
      if (row.members && row.members.length > 0) {
        row.member_names = row.members ? row.members.map(item => item.member_name).join(',') : ''
      }
      this.rowObj = row
    },
    handleTargetChange(val) {
      const currentTarget = this.$until.getLabelNameNew({ arr: this.$store.state.trainRooms, id: val })
      if (currentTarget.secure_person_id) {
        if (currentTarget.secure_person_id && JSON.stringify(this.users).indexOf(currentTarget.secure_person_id) == -1) {
          this.users.push({ id: currentTarget.secure_person_id, name: currentTarget.secure_person, number: currentTarget.secure_person_number })
        }
        this.ruleForm.member_id = currentTarget.secure_person_id
      }else{
        this.ruleForm.member_id = ''
      }
    },
    handleEditNew(row, extraKeys = ['id']) {
      this.type = 'edit'
      this.title = "编辑"
      this.ruleForm = this.assignFormObj(this.ruleForm, row, extraKeys)

      if (row.member_id && JSON.stringify(this.users).indexOf(row.member_id) == -1) {
        this.users.push({ id: row.member_id, name: row.member_name, number: row.member_number })
      }
      if (row.reports && row.reports.length > 0) {
        this.ruleForm.standards = row.reports.map(item => {
          return item.standard_name
        })
      }
      this.centerDialogVisible = true;
    },
    async remoteMethod(query, isConcat = false) {
      this.loading = true;
      this.users = [];
      let params = {
        page: 1,
        size: 10,
        name: query,
        // type: 3
      };
      let res = await this.$api.query.getUsersUnLoad(params);
      if (res.code == 0 && res.data) {
        if (isConcat) {
          this.users = this.users.concat(res.data.data);
        } else {
          this.users = res.data.data;
        }
      }
      this.loading = false;

    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/self-check-activity/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.instance.interfaceServer('api/self-check-activity/create', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);
      let res = await this.$api.instance.interfaceServer(`api/self-check-activity/update/${params.id}`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    handleQuery() {
      this.$refs.pageChild.page = 1;
      this.getList();
    },
  },
};
</script>
<style lang="less">
.pageHeader:before {
  width: var(--width);
}

.el-cascader-node {
  height: auto !important;
  line-height: 2;
}

.el-cascader__dropdown {
  max-width: 100% !important;
  overflow: auto;
}

.el-cascader-node__label {
  line-height: 1.2;
}

.cascader-tip {
  color: rgb(132, 146, 166);
  font-size: 13px;
  max-width: 400px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin-bottom: 12px;
}
</style>
